import '@emotion/react';
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var element = 'label';
var selectors = ['label.checkbox', 'label.radio'];
var baseStyles = process.env.NODE_ENV === "production" ? {
  name: "rm45mf",
  styles: "display:flex;align-items:center;gap:var(--spacing-l2);cursor:pointer;font:var(--body-1)"
} : {
  name: "k56d2b-baseStyles",
  styles: "display:flex;align-items:center;gap:var(--spacing-l2);cursor:pointer;font:var(--body-1);label:baseStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export { baseStyles, element, selectors };
